import script from "./TaxCodeMapping.vue?vue&type=script&setup=true&lang=js"
export * from "./TaxCodeMapping.vue?vue&type=script&setup=true&lang=js"

import "./TaxCodeMapping.vue?vue&type=style&index=0&id=e78b26bc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e78b26bc"]])

export default __exports__